<div class="container" fxLayoutAlign="end strech">
  <div fxShow>
    <mat-card class="mat-elevation-z12 card-login">
      <form [formGroup]="loginForm" (ngSubmit)="login(loginForm.value)">
        <mat-card-title class="card-title">----- Iniciar Sesión -----</mat-card-title>
        <mat-card-content>
          <mat-form-field class="full-width" appearance="outline">
            <input matInput formControlName="username" placeholder="Usuario" maxlength="100" required>
            <mat-icon matSuffix>person</mat-icon>
            <mat-error *ngIf="loginForm.controls['username'].hasError('required')">
              Usuario es <strong>requerido</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width" appearance="outline">
            <input matInput formControlName="password" placeholder="Contraseña" [type]="hide ? 'password' : 'text'"
              maxlength="15" required>
            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            <mat-error *ngIf="loginForm.controls['password'].hasError('required')">
              Contraseña es <strong>requerida</strong>
            </mat-error>
          </mat-form-field>

        </mat-card-content>
        <mat-card-actions>
          <button mat-raised-button color="primary" type="submit" class="align-center-middle">
            <span class="text-icon-space">Iniciar Sesión</span>
            <mat-icon>login</mat-icon>
          </button>
        </mat-card-actions>
        <div class="alert-danger" *ngIf="isLoggedFailed">
          {{ messageError }}
        </div>
        <div>
          <p><a routerLink="/forgotpassword">Recuperar Contraseña</a></p>
        </div>
      </form>
      <mat-divider inset></mat-divider>
      <div class="margin-top-10px">
        <p>&#9400; Todos los derechos reservados</p>
      </div>
    </mat-card>
  </div>
</div>
